import React, { Component } from "react";
import { connect } from "react-redux";
import OwlCarousel from "react-owl-carousel2";
import { Link, withRouter } from "react-router-dom";
import {
  secondToTime,
  returnDate,
  IsEmpty,
  convertToSlug,
  redirectionWrapper,
  getAssociationUrlPrefix
} from "../../../util/commonFunctions";
import { showLoader, hideLoader } from "../../../actions";
import LazyLoad from 'react-lazyload';
import { forceCheck } from 'react-lazyload';

class Rail extends Component {
  state = {
    options: {
      margin: 15,
      rewind: false,
      autoplay: false,
      dots: false,
      loop: false,
      responsive: {
        992: {
          items: 4,
          slideBy: 4,
          nav: true
        },
        768: {
          items: 3,
          slideBy: 3,
          nav: true
        },
        480: {
          items: 2,
          slideBy: 2,
          nav: false
        },
        320: {
          items: 1,
          slideBy: 1,
          nav: false
        }
      }
    }
  };

  formatArray(arr) {
    if (arr.length === 0) {
      return '';
    } else if (arr.length === 1) {
      return arr[0];
    } else if (arr.length === 2) {
      return arr.join(' and ');
    } else {
      return `${arr.slice(0, -1).join(', ')}, and ${arr[arr.length - 1]}`;
    }
  }
  
  getSlides = slides =>
    slides.map((slide, index) => {
      let redirectUrl = getAssociationUrlPrefix(slide.associationType);
      let associationId = slide.associationId == null ? slide.topic?.id : slide.associationId;
      let associationName = slide.associationName == null ? slide.topic?.name : slide.associationName;
      let isExpertListed = (slide.experts && slide.experts.length > 0) ? true : false;
      let altText = isExpertListed ? `${this.formatArray(slide.experts.map(exp => exp.name))} ${slide.experts.length > 1 ? 'report on' : 'reports on'} ${slide.title} [${slide.topic.name}]` : `${slide.title} [${slide.topic.name}]`

      return (
        <div
          className={slide.islive ? "railSlide relative" : "railSlide"}
          key={"slide" + index}
        >
          {index === 0 &&
            <span className="latest-video">LATEST</span>
          }
          <Link
            to={
              !IsEmpty(this.props.railId)
                ? "/media/" +
                convertToSlug(slide.title) +
                "?videoId=" +
                slide.id +
                "&sectionId=" +
                this.props.railId
                : "/media/" +
                convertToSlug(slide.title) +
                "?videoId=" +
                slide.id
            }
            {...(!IsEmpty(this.props.getIndexOfClicked)
              ? { onClick: event => this.props.getIndexOfClicked(event, index) }
              : {})}
          >
            <LazyLoad
              offset={50}
              once={true}
              key={index}
              height={200}
              placeholder={<img src="/assets/svg/abiz_placeholder.svg" className="img-fluid" />}
              debounce={500}
            >
              <img src={slide.imageUrl} alt={altText} width="266px" height="149px" />
            </LazyLoad>
            <div className="duration">
              <span></span>
              {secondToTime(slide.duration)}
            </div>
          </Link>
          {slide.islive && <div className="nowPlaying">Now Playing</div>}
          <div className="vodInfo text-left">
            <Link
              to={
                !IsEmpty(this.props.railId)
                  ? "/media/" +
                  convertToSlug(slide.title) +
                  "?videoId=" +
                  slide.id +
                  "&sectionId=" +
                  this.props.railId
                  : "/media/" +
                  convertToSlug(slide.title) +
                  "?videoId=" +
                  slide.id
              }
              {...(!IsEmpty(this.props.getIndexOfClicked)
                ? { onClick: event => this.props.getIndexOfClicked(event, index) }
                : {})}
            >
              <h4>{slide.title}</h4>
            </Link>
            <ul className="d-flex flex-row justify-content-between vod_com_time">
              <li className={slide.following ? "video-verified" : null}>
                <a
                  href={`/${redirectUrl}/${associationName}/${associationId}`}
                  onClick={event => {
                    redirectionWrapper(
                      redirectUrl,
                      event,
                      associationId,
                      associationName,
                      this.props,
                      this.props.showLoader,
                      this.props.hideLoader,
                      this.props.currentLanguage
                    )
                  }
                  }
                >
                  {associationName}
                </a>
              </li>
              <li>{returnDate(slide.publish_date, false)}</li>
            </ul>
          </div>
        </div>
      );
    });

  componentDidMount() {
    forceCheck();
  }

  componentWillUnmount() { }

  componentDidUpdate = () => {
    forceCheck();
    if (
      (!IsEmpty(this.props.startPosition) || this.props.startPosition == 0) &&
      this.props.data.length > 0
    ) {
      this.refs.car.goTo(this.props.startPosition);
    }
  };

  render = () => {
    const events = {
      onDragged: function (event) { },
      onChanged: function (event) { },
      onTranslate: function (event) { }
    };

    let redirectUrl = getAssociationUrlPrefix(this.props.subType ? this.props.subType : null);

    return (
      <React.Fragment>
        {this.props.data.length > 0 && (
          <div
            className={
              this.props.theme
                ? this.props.theme + " " + this.props.railType
                : this.props.railType
            }
          >
            <div className="rail_wrapper">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex flex-row justify-content-between align-items-center">
                      <h3 className="text-left">{this.props.title}</h3>
                      {!IsEmpty(this.props.seeAllUrl) &&
                        this.props.showSeeAll ? (
                        <a
                          to={
                            "/all/" +
                            convertToSlug(this.props.title) +
                            "?sectionId=" +
                            this.props.railId
                          }
                          href={`/${redirectUrl}/${this.props.seeAllUrl.name}/${this.props.seeAllUrl.id}`}
                          onClick={event =>
                            redirectionWrapper(
                              redirectUrl,
                              event,
                              this.props.seeAllUrl.id,
                              this.props.seeAllUrl.name,
                              this.props,
                              this.props.showLoader,
                              this.props.hideLoader,
                              this.props.currentLanguage
                            )
                          }
                          className="seeAll"
                        >
                          See all
                        </a>
                      ) : (
                        !IsEmpty(this.props.railId) &&
                        this.props.showSeeAll && (
                          <Link
                            to={
                              "/all/" +
                              convertToSlug(this.props.title) +
                              "?sectionId=" +
                              this.props.railId
                            }
                            className="seeAll"
                          >
                            See all
                          </Link>
                        )
                      )}
                      {this.props.cstmSeeAll && (
                        <span
                          className="seeAll"
                          onClick={() => this.props.cstmSeeAll("series_videos")}
                        >
                          See all
                        </span>
                      )}
                    </div>
                    <div className="railMobile text-center">
                      {this.props.data.length > 0 && (
                        <OwlCarousel
                          ref="car"
                          options={this.state.options}
                          events={events}
                        >
                          {this.getSlides(this.props.data)}
                        </OwlCarousel>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  };
}

const mapStateToProps = state => {
  return {
    currentLanguage: state.language.currentLanguage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Rail));
